<template>
  <div class="flex items-center text-sm font-medium ml-1.5">
    <media-time ref="timeStart" class="time" type="current" :class="saysIsLive && 'hidden'"/>
    <div class="mx-1 text-white/80" :class="saysIsLive && 'hidden'">/</div>
    <media-time ref="timeDuration" class="time" type="duration" :class="saysIsLive && 'hidden'"/>
    <p v-if="saysIsLive" class="select-none rounded-md bg-white px-2 py-1 text-xs font-bold text-black">Recorded just now</p>
  </div>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from "vue";

const timeStart = ref(null);
const timeDuration = ref(null);
const saysIsLive = ref(false);

const handleSaysIsLive = () => saysIsLive.value = timeStart.value.innerText === "LIVE" || timeDuration.value.innerText === "LIVE";

const checkForLiveText = (mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === "childList") handleSaysIsLive();
  }
};

let observer = new MutationObserver(checkForLiveText);

onMounted(() => {
  handleSaysIsLive();
  observer.observe(timeStart.value, {childList: true, subtree: true, characterData: true});
  observer.observe(timeDuration.value, {childList: true, subtree: true, characterData: true});
});

onUnmounted(() => observer.disconnect());
</script>

<style scoped>
.time {
  contain: content;
}
</style>
